import { notifications } from "@mantine/notifications"
import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { AddProductionSiteFieldDefinitionToProducts } from "@tfg/types/schemas/modules/traceability/queries/add-production-site-field-definition-to-products.dto"

import { httpClient } from "~/backend/axios"

export const useAddProductionSiteFieldDefinitionToProductsMutation = (
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    AddProductionSiteFieldDefinitionToProducts
  >
) =>
  useMutation({
    mutationFn: async (body: AddProductionSiteFieldDefinitionToProducts) => {
      return await httpClient.put(
        `/admin/traceability/add-production-site-field-definition-to-products`,
        body
      )
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)

      notifications.show({
        title: "Success",
        message: "Production field definition added to all products",
        color: "green",
      })
    },
    onError: (error: AxiosError) => {
      notifications.show({
        title: "Error",
        message: error.message,
        color: "red",
      })
    },
  })
